//var platform = () =>import (`@/page/statistics/platformTD.vue`)
var platform = () =>import (`@/page/statistics/platformTC.vue`)

export default [
  {
    name: 'Platform',
    path: 'index',
    component: platform,
    meta: {
      title: '平台'
    }
  },
  // 如果首页是 /contentIntro.action就需要配置个路由
  // {
  //   name: '工作台',
  //   path: '/contentIntro.action',
  //   component: () => import ( `@/views/pub/pubIndex.vue`),
  // }
];
